'use client';

import { useSelectedLayoutSegment } from 'next/navigation';
import { type PropsWithChildren, type ReactElement } from 'react';

import { type BasePageParams } from '@/app/urls/url-mapping';
import { urlToDatoLocale } from '@/lib/utils/locale';
import { PageContext } from './page-context';

type Props = PropsWithChildren<Pick<BasePageParams, 'region' | 'language'>>;

export const PageContextProvider = (props: Props): ReactElement => {
  const { children, language, region } = props;
  const page = useSelectedLayoutSegment() || '';

  return (
    <PageContext.Provider
      value={{
        params: { language, region },
        locale: urlToDatoLocale[`${region}${language}`],
        cmsData: {},
        pageData: {
          gaPageType: page,
          gaCategory: '',
          languageOptions: [],
        },
      }}
    >
      {children}
    </PageContext.Provider>
  );
};
